.d{justify-content:center;}